import { getRGBA } from 'utils/color'
import { useStyles } from './styles'

export interface IChip {
  status: string
  color?: string
}

const Chip: React.FC<IChip> = ({ status, color }) => {
  const classes = useStyles({ color })

  if (!color) {
    color = '#BDBDBD'
  }

  return (
    <span
      className={classes.root}
      style={{
        backgroundColor: getRGBA(color, 0.08),
        color: color,
      }}
    >
      {status}
    </span>
  )
}

export default Chip
